// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"tj","place_order_copy":"uj","next_order_copy":"vj","title_wrapper":"wj","get_it_now_row":"xj","get_it_now_remaining_items":"yj","get_it_now_remaining_items_mob":"zj","order_summary":"Aj","additional_items":"Bj","account_content_slider":"Cj","ingredient_carousel":"Ej","ingredient_carouselwrapper":"Fj","account_content_slide":"Gj","account_subscription_section_mob":"Hj","carouselwrapper":"Ij"};
    if(module.hot) {
      // 1715276852781
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  